export default __webpack_public_path__ + "static/media/Weather-Dash.e04d1719.png";